import React from "react";
import {
	Document,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";
import {
	MetricsProps,
	ACTIVITY_COUNT,
	ENROLLMENT_DISTRIBUTION,
	COMPLETION_RATE,
	ACTIVITY_ACCURACY,
	YEAR_LEVEL,
} from "../../../api/types";
import { siLogoBase64 } from "../assets/icon/siLogo";

export interface DocumentProps {
	data: MetricsProps;
}

const styles = StyleSheet.create({
	icon: {
		position: "absolute",
		width: "15%",
		left: 863,
		top: 47,
	},
	chartContainer: {
		position: "absolute",
		top: 150,
		width: 1023,
		marginHorizontal: 50,
		flexDirection: "column",
	},
	chartRow: {
		flexDirection: "row",
		width: 1023,
		marginBottom: 20,
	},
});

export const MetricsTemplate: React.FC<DocumentProps> = ({ data }) => {
	if (data) {
		return (
			<Document title={"Metrics Results"}>
				<Page size={[1123, 794]}>
					<Image
						style={styles.icon}
						// Due to unknown reason, Science Island logo cannot be recognized by <Image /> component
						// we have to convert image to base64 string, and it will be rendered
						src={`data:image/png;base64, ${siLogoBase64}`}
					/>
					<View style={styles.chartContainer}>
						<ChartRows data={data} />
					</View>
				</Page>
			</Document>
		);
	} else
		return (
			<Document>
				<Page size="A4">
					<View>
						<Text>This Pdf could not be generated</Text>
					</View>
				</Page>
			</Document>
		);
};

const ChartRows: React.FC<DocumentProps> = ({ data }) => {
	return (
		<View>
			<View style={styles.chartRow}>
				{data.imageURLs.get(ACTIVITY_COUNT) ? (
					<Image
						style={{
							width: 614,
						}}
						src={data.imageURLs.get(ACTIVITY_COUNT)}
					/>
				) : null}
				{data.imageURLs.get(ENROLLMENT_DISTRIBUTION) ? (
					<Image
						style={{
							width: 409,
						}}
						src={data.imageURLs.get(ENROLLMENT_DISTRIBUTION)}
					/>
				) : null}
			</View>
			<View style={styles.chartRow}>
				{data.imageURLs.get(COMPLETION_RATE) ? (
					<Image
						style={{
							width: 511.5,
						}}
						src={data.imageURLs.get(COMPLETION_RATE)}
					/>
				) : null}
				{data.imageURLs.get(ACTIVITY_ACCURACY) ? (
					<Image
						style={{
							width: 511.5,
						}}
						src={data.imageURLs.get(ACTIVITY_ACCURACY)}
					/>
				) : null}
			</View>
			<View style={styles.chartRow}>
				{data.imageURLs.get(YEAR_LEVEL) ? (
					<Image
						style={{
							width: 1023,
						}}
						src={data.imageURLs.get(YEAR_LEVEL)}
					/>
				) : null}
			</View>
		</View>
	);
};
